import { render } from "./xsjjDetail.vue?vue&type=template&id=8972f4ce&scoped=true&ts=true"
import script from "./xsjjDetail.vue?vue&type=script&lang=ts"
export * from "./xsjjDetail.vue?vue&type=script&lang=ts"

import "./xsjjDetail.vue?vue&type=style&index=0&id=8972f4ce&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8972f4ce"]])

export default __exports__